import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDanger = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 37,
	height: 32,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("title", { children: "background" }),
			/* @__PURE__ */ _jsx("rect", {
				fill: "none",
				id: "canvas_background",
				height: 34,
				width: 39,
				y: -1,
				x: -1
			}),
			/* @__PURE__ */ _jsx("g", {
				display: "none",
				overflow: "visible",
				y: 0,
				x: 0,
				height: "100%",
				width: "100%",
				id: "canvasGrid",
				children: /* @__PURE__ */ _jsx("rect", {
					fill: "url(#gridpattern)",
					strokeWidth: 0,
					y: 0,
					x: 0,
					height: "100%",
					width: "100%"
				})
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("title", { children: "Layer 1" }), /* @__PURE__ */ _jsx("g", {
			stroke: "null",
			id: "svg_9",
			children: /* @__PURE__ */ _jsxs("g", {
				stroke: "null",
				transform: "matrix(0.7855302431170932,0,0,0.7687523028504214,91.72093306770546,92.32493254420888) ",
				id: "svg_4",
				children: [
					/* @__PURE__ */ _jsx("path", {
						stroke: "null",
						id: "svg_6",
						d: "m-93.848603,-120.727277a21.52,21.52 0 0 0 -21.5,21.5c1.18,28.52 41.82,28.51 43,0a21.52,21.52 0 0 0 -21.5,-21.5zm0,40a18.52,18.52 0 0 1 -18.5,-18.5c1,-24.54 36,-24.54 37,0a18.52,18.52 0 0 1 -18.5,18.5z"
					}),
					/* @__PURE__ */ _jsx("path", {
						stroke: "null",
						id: "svg_7",
						d: "m-93.848603,-94.617277a1.5,1.5 0 0 0 1.5,-1.5l0,-12a1.5,1.5 0 0 0 -3,0l0,12a1.5,1.5 0 0 0 1.5,1.5z"
					}),
					/* @__PURE__ */ _jsx("path", {
						stroke: "null",
						id: "svg_8",
						d: "m-93.848603,-92.527277a1.59,1.59 0 0 0 0,3.18a1.59,1.59 0 0 0 0,-3.18z"
					})
				]
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgDanger);
export default ForwardRef;
